module.exports = __webpack_public_path__ + "images/eleven-year-club-cb54d36c4e5e078c6fe2226d2f06f764.png";